export default __webpack_public_path__ + "static/media/todoapp.729a75fb.png";